export function headerFunc() {
  toggleMenu()
}

/**
 * ハンバーガーメニュー（フルスクリーンメニューの開閉）
 */
function toggleMenu() {
    const toggleButton = document.querySelector('.l-header__toggle-button');
    const menu = document.querySelector('.l-menu');

    if (!toggleButton || !menu) return;

    const setState = (isOpen) => {
      toggleButton.classList.toggle('l-header__toggle-button--close', isOpen);
      menu.classList.toggle('l-menu--open', isOpen);
      document.body.classList.toggle('is-menu-open', isOpen);
      toggleButton.setAttribute('aria-expanded', String(isOpen));
      menu.setAttribute('aria-hidden', String(!isOpen));
    };

    // トグルボタンで開閉
    toggleButton.addEventListener('click', function () {
      const willOpen = !toggleButton.classList.contains('l-header__toggle-button--close');
      setState(willOpen);
    });

    // メニュー内リンクの押下で閉じる
    menu.querySelectorAll('a[href]').forEach(function (link) {
      link.addEventListener('click', function () {
        setState(false);
      });
    });

    // Escキーで閉じる
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('l-menu--open')) {
        setState(false);
      }
    });
}
